import { useInfoCenterPublic } from '@content-api/provider';
import { Typography, Loading } from '@ui/components';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import React from 'react';

interface HelpProps {
  withTitle?: boolean;
  className?: string;
}

export const Help: FC<HelpProps> = ({ withTitle = true }) => {
  const { getContactUs } = useInfoCenterPublic();
  const { t } = useTranslation();

  const { data: contactUs, isLoading } = useQuery({
    queryKey: ['content-api', 'contact-us'],
    queryFn: () => getContactUs(),
  });

  const phoneNumbers = contactUs?.data.phoneNumbers.split(',');

  return (
    <Loading isLoading={isLoading}>
      {withTitle && (
        <Typography variant="labelLargeBook" className="pt-1 mb-6">
          {t('HELP.CONTACT_WITH_US')}
        </Typography>
      )}

      <Typography variant="labelMediumMedium" className="text-weak">
        {contactUs?.data.openingHours}
      </Typography>

      <section className="flex flex-wrap gap-2 mt-4 items-center">
        {phoneNumbers?.map((phoneNumber, index) => (
          <React.Fragment key={phoneNumber}>
            {index !== 0 && (
              <Typography className="text-weak" variant="h100">
                {t('HELP.OR')}
              </Typography>
            )}
            <Typography variant="labelLargeBook">{phoneNumber}</Typography>
          </React.Fragment>
        ))}
      </section>

      <section className="mt-4">
        <Typography className="text-weak whitespace-pre-line" variant="labelMediumMedium">
          {contactUs?.data.address}
        </Typography>
      </section>
    </Loading>
  );
};
